import { render, staticRenderFns } from "./dui-gallery-vessel.vue?vue&type=template&id=6bac68f0&"
import script from "./dui-gallery-vessel.vue?vue&type=script&lang=js&"
export * from "./dui-gallery-vessel.vue?vue&type=script&lang=js&"
import style0 from "./dui-gallery-vessel.vue?vue&type=style&index=0&id=6bac68f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports